export default __webpack_public_path__ + "static/media/melodicalflute.0d3d598a.mp3";